<template lang="pug">

.version
  .date {{ date | moment("h:mmA MMM D, YYYY") }}
  .build Build: {{ version.build }}

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'version',
  components: {},
  data() {
    return {}
  },
  props: {},
  computed: {
    date() {
      return new Date(this.version.date)
    },
    ...mapState('app', ['version']),
  },
  mounted() {
    window.Version = this
  },
  beforeDestroy() {},
  methods: {},
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.version
  position: absolute
  bottom: 0
  right: 0
  font-size: 6px
  font-family: Monaco !important
  color: white
  background: rgba(0,0,0,0.5)

li
  +flex-center()
  flex-direction: row

.value
  width: 3rem

</style>
